import { useEffect } from "react";
import Lenis from "lenis";

// Smooth wheel scrolling on the customer site only — skipped for touch, reduced motion and staff screens.
export default function useLenis(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    const coarse = window.matchMedia("(pointer: coarse)").matches;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (coarse || reduced) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, [enabled]);
}
